

















import {Component, Prop, Vue} from 'vue-property-decorator'
@Component({
  components: {},
})
export default class TableCell extends Vue {
  @Prop() public item!: any     // Element to be rendered
  @Prop() public type!: string  // Cell type
  @Prop() public path!: string  // Key to access the element
  @Prop() public template!: string

  public dotGetter(item: any, path: string) {

    let p = path.split(".")
    p.forEach((y) => {
      if (item)
        item = item[y]
    })
    return item
  }
  public getText(str: string) {
    if (this.template) {
      return this.template.replace('#', str)
    }
    return str
  }
}
